import { useAppSelector } from 'src/utils/Hooks';

export interface AppFilters {
  /**
   * A boolean to determine if there are active filters in the URL
   */
  hasActiveFilters: boolean;
  /**
   * An object containing active filters for category, subcategory, and segments for use in Advanced Search requests
   */
  appFilters: {
    categoryFilters: number[] | string[];
    subcategoryFilters: number[] | string[];
    segmentFilters: {
      /**
       * Segment id
       */
      id: string;
      /**
       * Segment name
       */
      dn: string;
      termFilters: { fieldName: string; values: string[] | number[]; condition: string }[];
      rangeFilters: { fieldName: string; minValue: string | number; maxValue: string | number }[];
    };
    businessUnitFilters: string[];
    retailPriceFilter: { min?: string; maxValue?: string };
  };
}

export const useBeaconFilters = (): AppFilters => {
  const filters = useAppSelector((state) => state.filters);

  const { category, subcategory, segment, businessUnits, retailPrice } = filters;

  return {
    hasActiveFilters: !!category || !!subcategory || !!segment || !!businessUnits || !!retailPrice,
    appFilters: {
      categoryFilters:
        category || subcategory
          ? Array.from(
              new Set([
                ...(category ? category.map((filteredCategory) => filteredCategory.id) : []),
                ...(subcategory ? subcategory.map((filteredSubcategory) => filteredSubcategory.parentCategoryId) : [])
              ])
            )
          : null,
      subcategoryFilters: subcategory ? subcategory.map((filteredSubcategory) => filteredSubcategory.id) : null,
      segmentFilters: segment
        ? {
            id: segment.id,
            dn: segment.dn,
            termFilters: segment.termFilters ? segment.termFilters : [],
            rangeFilters: segment.rangeFilters ? segment.rangeFilters : []
          }
        : null,
      businessUnitFilters: businessUnits || null,
      retailPriceFilter: retailPrice || null
    }
  };
};
